import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import svTranslation from '../locales/sv/translation.json';
import enTranslation from '../locales/en/translation.json';

const resources = {
  sv: {
    translation: svTranslation
  },
  en: {
    translation: enTranslation
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'sv',
    debug: false, // Disable debug mode to reduce console noise
    
    // Language detection options (only works when LanguageDetector is enabled)
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // Namespace configuration
    defaultNS: 'translation',
    ns: ['translation'],

    // React i18next options
    react: {
      useSuspense: false, // Disable suspense for better compatibility
    },

    // Reduce logging for missing keys
    saveMissing: false,
    missingKeyHandler: false,
    missingKeyNoValueFallbackToKey: true,
  })
  .then(() => {
    if (process.env.NODE_ENV === 'development') {
      console.log('i18n initialized successfully');
      console.log('Current language:', i18n.language);
      console.log('Available languages:', i18n.languages);
    }
  })
  .catch((error) => {
    console.error('i18n initialization failed:', error);
  });

export default i18n;